import { createApp } from 'vue'
import App from './App.vue'
// import "./axios"
import router from './router'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

import "./assets/font/iconfont/iconfont.css"
import "./assets/font/fontFamily/font.css"

import Swiper from 'r-swiper'

// 动画 animate.css
import animate from "animate.css";

const app = createApp(App)
app.use(router)
app.use(Antd)
app.use(Swiper)

app.mount('#app')
